    <div class="row">
        <div class="col">
            <h1>Canchas</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8">
            <button type="button" mat-raised-button color="primary" disabled>Agregar Cancha</button>
        </div>
    </div>
      
      <table mat-table [dataSource]="canchas" class="table mat-elevation-z8">
      
          <ng-container matColumnDef="Nombre">
            <th mat-header-cell *matHeaderCellDef> Nombre </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
          <ng-container matColumnDef="Size">
              <th mat-header-cell *matHeaderCellDef> Capacidad </th>
              <td mat-cell *matCellDef="let element">
                <span *ngFor="let c of element.capacities">{{ c.description }}, </span>
              </td>
          </ng-container>
          <ng-container matColumnDef="TipoTurno">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let element"> Habilitada </td>
          </ng-container>
          <ng-container matColumnDef="More">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element" width="20"><i class="material-icons">more_vert</i></td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      
      <!-- >div class="row" id="content">
          <div class="col">
              <table class="table table-hover table-pilka mt-4">
                  <thead class="shadow-sm">
                    <tr>
                      <th width="50"></th>
                      <th scope="col">Nombre</th>
                      <th width="150" scope="col">Estado</th>
                      <th width="150" scope="col">Capacidad</th>
                      <th width="150" scope="col">Tipo Turno</th>
                      <th width="20" scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cancha of canchas" >
                      <td></td>
                      <td>{{ cancha.name }}</td>
                      <td></td>
                      <td>{{ cancha.size }}</td>
                      <td></td>
                      <td><i class="material-icons">more_vert</i></td>
                    </tr>
                  </tbody>
                </table>      
          </div>
      </div-->
      
